/* Flick · Carrito — cantidad y eliminar por AJAX (/cart/change.js) */
(function () {
  function money(cents) {
    return '€' + (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.dataset.fkReady) return;
    root.dataset.fkReady = '1';

    var subtotalEl = root.querySelector('[data-fk-subtotal]');
    var totalEl = root.querySelector('[data-fk-total]');

    function change(key, qty, row) {
      row.setAttribute('data-fk-busy', '');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || cart.item_count === 0) { window.location.reload(); return; }
        // ¿sigue existiendo la línea?
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) {
          row.style.height = row.offsetHeight + 'px';
          row.addEventListener('transitionend', function () { row.remove(); }, { once: true });
          requestAnimationFrame(function () { row.style.height = '0'; row.style.opacity = '0'; row.style.padding = '0'; row.style.overflow = 'hidden'; });
        } else {
          var priceEl = row.querySelector('[data-fk-line-price] span');
          if (priceEl) priceEl.textContent = money(line.final_line_price);
          var input = row.querySelector('[data-fk-qinput]');
          if (input) input.value = line.quantity;
          row.removeAttribute('data-fk-busy');
        }
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        if (totalEl) totalEl.textContent = money(cart.total_price);
        // actualizar contador de la cabecera del tema si existe
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count').forEach(function (c) {
          if (/^\d+$/.test(c.textContent.trim())) c.textContent = cart.item_count;
        });
      }).catch(function () { window.location.reload(); });
    }

    var timers = {};
    function queue(row) {
      var key = row.dataset.key;
      var input = row.querySelector('[data-fk-qinput]');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () { change(key, qty, row); }, 420);
    }

    root.querySelectorAll('[data-fk-item]').forEach(function (row) {
      var input = row.querySelector('[data-fk-qinput]');
      row.querySelectorAll('[data-fk-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.fkStep, 10));
          input.value = v;
          queue(row);
        });
      });
      if (input) {
        input.addEventListener('change', function () { queue(row); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); queue(row); } });
      }
      var rm = row.querySelector('[data-fk-remove]');
      if (rm) rm.addEventListener('click', function () { change(row.dataset.key, 0, row); });
    });
  }

  function boot() { document.querySelectorAll('[data-fk-cart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
